import React from 'react';
import { m } from 'framer-motion';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-cream pb-10 pt-8 sm:pb-14 sm:pt-12" data-id="element-73" data-mp="cv32tt32i8e9">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[380px] w-[680px] -translate-x-1/2 rounded-full bg-orange/10 blur-3xl" aria-hidden="true" data-id="element-74" data-mp="hvz3zyw1bgfz" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-75" data-mp="qv3zsxg7ovog">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-76" data-mp="vm2k084bmdwz">
          <SectionTag icon="📚" tone="navy" data-id="element-77" data-mp="10kdw6pi390id">
            Recursos y Clases Estructuradas por Curso
          </SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-4xl font-extrabold uppercase leading-[1.08] tracking-tight text-navy sm:text-5xl md:text-6xl" data-id="element-78" data-mp="15ife373s2ts9">
          Matemáticas <span className="text-orange-hover" data-id="element-79" data-mp="4r2j38g5jjuw">Listo</span>
        </m.h1>

        <img src="https://cdn.magicpatterns.com/uploads/f2eTxnHq9k3hAMZNZj5Peg/ChatGPT_Image_7_sept_2026,_12_43_15_-_Editado.png" alt="Matemáticas Listo: colección de 12 tomos y 6 bonos premium" width={500} height={500} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-[420px] sm:max-w-[500px]" data-id="element-80" data-mp="3vvj1xy19z6lu" />

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-8 max-w-2xl text-lg font-semibold leading-relaxed text-navy sm:text-xl" data-id="element-81" data-mp="im4n1q1fuz52">
          12 tomos + 6 bonos + <span className="text-orange-hover" data-id="element-82" data-mp="16cif3gk0wxzn">360 clases estructuradas</span> distribuidas
          entre 12 cursos
        </m.p>

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.22
      }} className="mt-3 max-w-xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-83" data-mp="35l0le26h0v8d">
          Guías para el profesor, actividades imprimibles y soluciones para preparar tus clases con un punto de
          partida claro.
        </m.p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.26
      }} className="mt-7 flex flex-col items-center" data-id="element-84" data-mp="2hxsfbi17xi5a">
          <PrimaryButton onClick={() => scrollToId('oferta')} data-id="element-85" data-mp="2cw31xvqiwse1">Quiero el Sistema por 19€</PrimaryButton>
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-86" data-mp="66513jgc6mzc">
            Acceso inmediato · Formato digital · De 1.º Primaria a 2.º Bachillerato
          </p>
        </m.div>
      </div>
    </header>;
}